<div class="ui basic segment" [class.loading]="isLoading">
    <app-pagination [total]="paginator.total" [current]="paginator.page" (pageChange)="paginator.page = $event">
    </app-pagination>

    <app-header title="{{ 'settings.xero-errors-and-events-log.header' | appTranslate }}" [back]="true"></app-header>

    <div *ngIf="!paginator?.total" class="ui segment empty">
        <h2 class="ui centered header">No Xero logs</h2>
    </div>

    <div class="ui segment" *ngIf="paginator?.total">
        <ng-container *ngFor="let log of paginator.values">
            <div class="flex-row">
                <p style="float: right">{{ formatDate(log.createdAt) }}</p>
                <h3 class="ui header">{{ log.status | capitalize }}</h3>
                <p *ngIf="!log.jsonMessages">{{ log.statusMessage }}</p>
                <ul *ngIf="log.jsonMessages">
                    <li *ngFor="let message of log.jsonMessages">{{ message }}</li>
                </ul>
            </div>
            <div class="ui divider"></div>
        </ng-container>
    </div>
</div>
